import Axios from 'util/service';
import {
    SET_ROUTE_DATA,
    SET_PARTIALS_DATA,
    SET_THEME,
    SET_COOKIE_CONSENT_DATA,
} from 'vue/vuex/mutation-types';


const DEBUG = globals.config.debug;


/**
 * Commit available route data into the vuex store
 */
export function setRouteData({ commit, state }, { key, value }) {
    const { data, partials = {} } = value;

    // Create a promise that acts as singleton data instance
    const FetchPromise = new Promise(resolve => resolve(data));

    // Implement enclosed partials data, when the route data is written to the store
    Object.entries(partials).forEach(([partialKey, partialValue]) => {
        setPartialsData({ commit, state }, { key: partialKey, value: partialValue });
    });

    // Commit promise to store
    commit(SET_ROUTE_DATA, { key, value: FetchPromise });

    // We directly return the generated FetchPromise for easier data handling in the getter method
    return FetchPromise;
}

/**
 * Retrieve route data from the store, conditionally requesting it from the api endpoint if not available
 */
export function getRouteData({ commit, state, dispatch }, { storageKey, fetchKey }) {
    let FetchPromise = state.routes[storageKey];

    DEBUG && console.log(`[vuex/router/actions] - Using ${ FetchPromise ? 'cached' : 'api' } data`);

    if (FetchPromise) {
        return FetchPromise;
    }

    return new Promise((resolve, reject) => {
        Axios.request({ url: fetchKey }).then(
            (request) => {
                resolve(dispatch('setRouteData', { key: storageKey, value: request.data }));
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * Add partials to the store: These are common components like menus, footer or breadcrumbs
 */
export function setPartialsData({ commit, state }, { key, value }) {
    return new Promise((resolve) => {
        commit(SET_PARTIALS_DATA, { key, value });
        resolve({
            partials: state.partials[key],
        });
    });
}

/**
 * Set the SIB theme colors for the page
 */
export function setTheme({ commit, state }, { theme, navTheme }) {
    commit(SET_THEME, { theme, navTheme });
}

/**
 * Add cookie consent data
 */
export function setCookieConsentData({ commit, state }, { data }) {
    commit(SET_COOKIE_CONSENT_DATA, { data });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/router/actions.js